import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./common/contexts/AuthContext";
import { MenuProvider } from "./common/contexts/MenuContext";
import { AccessMenuProvider } from "./common/contexts/AccessMenuContext";
import './common/config/axios';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <AccessMenuProvider>
        <MenuProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MenuProvider>
      </AccessMenuProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
